import React from "react";

import LandingLayout from "components/common/landingLayout";
import DigitalSolution from "components/digitalSolution";

const DigitalSolutionPage = () => {
  return (
    <LandingLayout>
      <DigitalSolution />
    </LandingLayout>
  );
};

export default DigitalSolutionPage;
